import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="min-h-[60vh] flex items-center justify-center font-serif-h text-2xl text-[#577731]">
        Opening the circle…
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/ambassadors?mode=login&next=${next}#join`} replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/members" replace />;
  return children;
};
